/* Sofiya Mart · collection filters (design match).
 * Filters the product cards on the page by category, device, price and
 * availability / on-sale, plus sorting, active chips and counts.
 * Filter controls are <button> elements; product cards carry data-cf-* too,
 * so every lookup targets buttons explicitly.
 */
(function () {
  'use strict';

  function init(root) {
    var grid = root.querySelector('[data-cf-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-sm-card]'));
    cards.forEach(function (c, i) { c.setAttribute('data-cf-index', String(i)); });

    var BTN_CAT = 'button[data-cf-cat]';
    var BTN_DEV = 'button[data-cf-device]';
    var BTN_PRICE = 'button[data-cf-price]';
    var BTN_TOGGLE = 'button[data-cf-toggle]';

    var state = { cats: {}, device: null, price: null, stock: false, sale: false, sort: 'featured' };
    var CAT_LABEL = {}, DEV_LABEL = {}, PRICE_LABEL = {};

    Array.prototype.forEach.call(root.querySelectorAll(BTN_CAT), function (b) { CAT_LABEL[b.getAttribute('data-cf-cat')] = b.getAttribute('data-cf-label'); });
    Array.prototype.forEach.call(root.querySelectorAll(BTN_DEV), function (b) { DEV_LABEL[b.getAttribute('data-cf-device')] = b.getAttribute('data-cf-label'); });
    var PRICE_RANGE = {};
    function num(v) { return v === null || v === '' || isNaN(parseFloat(v)) ? null : parseFloat(v); }
    Array.prototype.forEach.call(root.querySelectorAll(BTN_PRICE), function (b) {
      var k = b.getAttribute('data-cf-price');
      PRICE_LABEL[k] = b.getAttribute('data-cf-label');
      PRICE_RANGE[k] = { min: num(b.getAttribute('data-min')), max: num(b.getAttribute('data-max')) };
    });
    var TOGGLE_LABEL = {};
    Array.prototype.forEach.call(root.querySelectorAll(BTN_TOGGLE), function (b) { TOGGLE_LABEL[b.getAttribute('data-cf-toggle')] = b.getAttribute('data-cf-label'); });

    function priceOf(c) { return parseFloat(c.getAttribute('data-cf-price')) || 0; }

    function matches(c) {
      if (Object.keys(state.cats).length && !state.cats[c.getAttribute('data-cf-cat')]) return false;
      if (state.device && (c.getAttribute('data-cf-devices') || '').indexOf('|' + state.device + '|') < 0) return false;
      if (state.price) {
        var p = priceOf(c);
        var rng = PRICE_RANGE[state.price] || {};
        if (rng.min !== null && rng.min !== undefined && p < rng.min) return false;
        if (rng.max !== null && rng.max !== undefined && p > rng.max) return false;
      }
      if (state.stock && c.getAttribute('data-cf-stock') !== '1') return false;
      if (state.sale && c.getAttribute('data-cf-sale') !== '1') return false;
      return true;
    }

    function setCounts() {
      Array.prototype.forEach.call(root.querySelectorAll(BTN_CAT), function (b) {
        var k = b.getAttribute('data-cf-cat');
        var n = cards.filter(function (c) { return c.getAttribute('data-cf-cat') === k; }).length;
        var el = b.querySelector('[data-cf-n]'); if (el) el.textContent = String(n);
      });
      Array.prototype.forEach.call(root.querySelectorAll(BTN_TOGGLE), function (b) {
        var k = b.getAttribute('data-cf-toggle');
        var n = k === 'stock'
          ? cards.filter(function (c) { return c.getAttribute('data-cf-stock') === '1'; }).length
          : cards.filter(function (c) { return c.getAttribute('data-cf-sale') === '1'; }).length;
        var el = b.querySelector('[data-cf-n]'); if (el) el.textContent = String(n);
      });
    }

    function esc(v) { return String(v).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
    function chip(key, label) {
      return '<button type="button" class="sm-cf__chip" data-cf-remove="' + esc(key) + '">' + esc(label) + ' <span aria-hidden="true">✕</span></button>';
    }

    function activeCount() {
      return Object.keys(state.cats).length + (state.device ? 1 : 0) + (state.price ? 1 : 0) + (state.stock ? 1 : 0) + (state.sale ? 1 : 0);
    }

    function setOn(el, on) {
      el.classList.toggle('is-active', on);
      if (el.getAttribute('role') === 'checkbox') el.setAttribute('aria-checked', on ? 'true' : 'false');
      else el.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function render() {
      var sorted = cards.slice();
      if (state.sort === 'low') sorted.sort(function (a, b) { return priceOf(a) - priceOf(b); });
      else if (state.sort === 'high') sorted.sort(function (a, b) { return priceOf(b) - priceOf(a); });
      else if (state.sort === 'az') sorted.sort(function (a, b) { return (a.getAttribute('data-cf-title') || '').localeCompare(b.getAttribute('data-cf-title') || ''); });
      else sorted.sort(function (a, b) { return parseInt(a.getAttribute('data-cf-index'), 10) - parseInt(b.getAttribute('data-cf-index'), 10); });
      sorted.forEach(function (c) { grid.appendChild(c); });

      var shown = 0;
      cards.forEach(function (c) { var ok = matches(c); c.hidden = !ok; if (ok) shown++; });

      Array.prototype.forEach.call(root.querySelectorAll(BTN_CAT), function (b) { setOn(b, !!state.cats[b.getAttribute('data-cf-cat')]); });
      Array.prototype.forEach.call(root.querySelectorAll(BTN_DEV), function (b) { setOn(b, state.device === b.getAttribute('data-cf-device')); });
      Array.prototype.forEach.call(root.querySelectorAll(BTN_PRICE), function (b) { setOn(b, state.price === b.getAttribute('data-cf-price')); });
      Array.prototype.forEach.call(root.querySelectorAll(BTN_TOGGLE), function (b) {
        setOn(b, b.getAttribute('data-cf-toggle') === 'stock' ? state.stock : state.sale);
      });

      var box = root.querySelector('[data-cf-chips]');
      if (box) {
        var html = '';
        Object.keys(state.cats).forEach(function (k) { html += chip('cat:' + k, CAT_LABEL[k] || k); });
        if (state.device) html += chip('device:' + state.device, DEV_LABEL[state.device] || state.device);
        if (state.price) html += chip('price:' + state.price, PRICE_LABEL[state.price] || state.price);
        if (state.stock) html += chip('stock', TOGGLE_LABEL.stock || 'In stock');
        if (state.sale) html += chip('sale', TOGGLE_LABEL.sale || 'On sale');
        box.innerHTML = html;
      }

      var n = activeCount();
      Array.prototype.forEach.call(root.querySelectorAll('button[data-cf-clear]'), function (b) {
        if (b.getAttribute('data-cf-clear') === 'all') b.hidden = n === 0;
      });
      var badge = root.querySelector('[data-cf-badge]');
      if (badge) badge.textContent = n ? ' (' + n + ')' : '';
      var count = root.querySelector('[data-cf-count]');
      if (count) {
        var tpl = shown === 1 ? (count.getAttribute('data-one') || '[count] product') : (count.getAttribute('data-many') || '[count] products');
        count.textContent = tpl.replace('[count]', String(shown));
      }
      var empty = root.querySelector('[data-cf-empty]');
      if (empty) empty.hidden = shown !== 0;
    }

    function clearAll() {
      state = { cats: {}, device: null, price: null, stock: false, sale: false, sort: state.sort };
      render();
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var rm = t.closest('button[data-cf-remove]');
      if (rm) {
        var key = rm.getAttribute('data-cf-remove');
        if (key.indexOf('cat:') === 0) delete state.cats[key.slice(4)];
        else if (key.indexOf('device:') === 0) state.device = null;
        else if (key.indexOf('price:') === 0) state.price = null;
        else if (key === 'stock') state.stock = false;
        else if (key === 'sale') state.sale = false;
        render();
        return;
      }

      var cat = t.closest(BTN_CAT);
      if (cat) {
        var ck = cat.getAttribute('data-cf-cat');
        if (state.cats[ck]) delete state.cats[ck]; else state.cats[ck] = true;
        render(); return;
      }

      var dev = t.closest(BTN_DEV);
      if (dev) {
        var dk = dev.getAttribute('data-cf-device');
        state.device = state.device === dk ? null : dk;
        render(); return;
      }

      var pr = t.closest(BTN_PRICE);
      if (pr) {
        var pk = pr.getAttribute('data-cf-price');
        state.price = state.price === pk ? null : pk;
        render(); return;
      }

      var tg = t.closest(BTN_TOGGLE);
      if (tg) {
        if (tg.getAttribute('data-cf-toggle') === 'stock') state.stock = !state.stock; else state.sale = !state.sale;
        render(); return;
      }

      var cl = t.closest('button[data-cf-clear]');
      if (cl) { clearAll(); return; }
    });

    var sortSel = root.querySelector('select[data-cf-sort]');
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; render(); });

    setCounts();
    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cf-root]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
